// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"244":"21ec96c4","7757":"21ec96c4","8429":"d00d3887"}[chunkId] + ".chunk.css";
};